import { useRef, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import CertificateModal from "./CertificateTemplate";

export default function KIGESportsCertificate() {
  const [captcha, setCaptcha] = useState({
    num1: Math.floor(Math.random() * 10),
    num2: Math.floor(Math.random() * 10),
    response: "",
  });
  const [showModal, setShowModal] = useState(false);
  // const pdfRef = useRef(null);
  const [email, setEmail] = useState("");
  const [isMailSent, setIsMailSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [jwt, setJWT] = useState(null);
  const [certificateData, setCertificateData] = useState({});
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  // Single loading indicator for all async calls
  const [loadingSendOTP, setLoadingSendOTP] = useState(false);
  const [loadingVerifyOTP, setLoadingVerifyOTP] = useState(false);
  const [loadingDownload, setLoadingDownload] = useState(false);

  async function sendEmailForOTP() {
    setLoadingSendOTP(true);
    try {
      // const res = await fetch("http://localhost:5002/api/test", {
      // const res = await fetch("http://localhost:5002/api/sendmail", {
      const res = await fetch("https://api.biharsports.org/api/sendmail", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });
      const val = await res.json();
      console.log(val);
      if (val?.success) {
        setIsMailSent(true);
      }
      alert(val?.message);
    } catch (error) {
      alert(error?.message);
    } finally {
      setLoadingSendOTP(false);
    }
  }
  async function verifyOTP() {
    setLoadingVerifyOTP(true);
    try {
      // const res = await fetch("http://localhost:5002/api/verify-otp", {
      const res = await fetch("https://api.biharsports.org/api/verify-otp", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, otp }),
      });
      const val = await res.json();
      console.log(val);
      if (val?.success) {
        setIsEmailVerified(true);
        setIsMailSent(false);
        setJWT(val?.token);
        setOtp("");
      }
      alert(val?.message);
    } catch (error) {
      alert(error.message);
    } finally {
      setLoadingVerifyOTP(false);
    }
  }
  async function getDownloadInfo(JWT) {
    setLoadingDownload(true);
    try {
      // const res = await fetch("http://localhost:5002/api/download", {
      const res = await fetch("https://api.biharsports.org/api/download", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${JWT}`,
        },
      });
      const val = await res.json();
      // alert(JSON.stringify(val));
      if (val?.success) {
        setCertificateData(val?.data);
        setShowModal(true);
      } else {
        alert(val?.message);
      }
    } catch (error) {
      alert(error?.message);
    } finally {
      setLoadingDownload(false);
    }
  }
  async function downloadKIYGCertificate(e) {
    e.preventDefault();
    // verify email, and captcha
    if (!isEmailVerified) {
      alert("Please verify your email first.");
      return;
    }
    if (!verifyCaptcha(captcha?.response)) {
      return;
    }
    if (jwt) await getDownloadInfo(jwt);
    // setShowModal(true);
    // setShowModal(true);
    // logic for download
    // need to send jwt as request with cookie or local storage
    // Trigger download (JWT should be sent automatically if in cookie)
    // window.location.href = "http://localhost:5002/api/download";
    // or for local storage
    // await downloadFromLocalStorage()
  }
  function verifyCaptcha(captchaResponse) {
    // sum of two numbers equal response, check
    const sum = captcha.num1 + captcha.num2;
    if (parseInt(captchaResponse) === sum) {
      return true;
    } else {
      alert("Captcha verification failed. Please try again.");
      return false;
    }
  }
  return (
    <>
      <div
        className="container my-5"
        style={{ padding: "2rem", overflow: "auto" }}
      >
        {/* heading kig esports certificate */}
        <h1 className="text-center mb-4">KIYG 2025 Esports Certificate</h1>
        {/* form with email input, send otp button single line, submit button triggers verifyemail function */}
        <form className="mb-4" onSubmit={downloadKIYGCertificate}>
          <Row>
            <Col md={10}>
              <div className="form-group">
                <Row>
                  <Col md={12}>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Enter your email"
                      disabled={loadingSendOTP || loadingVerifyOTP || loadingDownload}
                    />
                  </Col>
                </Row>
              </div>
            </Col>
            <Col md={2}>
              <button
                type="button"
                onClick={sendEmailForOTP}
                className="btn btn-primary mt-2"
                disabled={!email || isMailSent || loadingSendOTP}
                style={{ width: "100%", margin: "1px" }}
              >
                {loadingSendOTP ? "Sending..." : "Send OTP"}
              </button>
            </Col>
          </Row>
          {/* otp input */}
          {isMailSent && (
            <Row>
              <Col md={12}>
                <div className="form-group mt-3">
                  <Row>
                    <Col md={10}>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter OTP"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                        disabled={loadingVerifyOTP || loadingDownload}
                      />
                    </Col>
                    <Col md={2}>
                      <button
                        type="button"
                        className="btn btn-success mt-2"
                        onClick={verifyOTP}
                        disabled={!otp || isEmailVerified || loadingVerifyOTP}
                        style={{ width: "100%", margin: "1px" }}
                      >
                        {loadingVerifyOTP ? "Verifying..." : "Verify Email"}
                      </button>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          )}
          {/* Capcha response input*/}
          {isEmailVerified && (
            <Row className="mt-3">
              <Col md={12}>
                <div className="form-group">
                  <Row>
                    <Col md={6}>
                      <div
                        style={{
                          border: "1px solid #ccc",
                          borderRadius: "5px",
                        }}
                      >
                        <label>
                          {captcha.num1} + {captcha.num2} = ?
                        </label>
                      </div>
                    </Col>
                    <Col md={6}>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter captcha response"
                        value={captcha.response}
                        onChange={(e) =>
                          setCaptcha({ ...captcha, response: e.target.value })
                        }
                        disabled={loadingDownload}
                      />
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          )}
          <Row style={{ marginTop: "1rem" }}>
            <button type="submit" className="btn btn-success mt-2 ml-2" disabled={loadingDownload}>
              {loadingDownload ? "Loading..." : "Download Certificate"}
            </button>
          </Row>
        </form>
      </div>
      {showModal && (
        <CertificateModal
          showModal={showModal}
          setShowModal={setShowModal}
          // cardRef={pdfRef}
          name={"Akshay Kumar Jha"}
          data={certificateData}
        />
      )}
    </>
  );
}
